import { useState, useEffect } from "react"
import styles from '@/styles/productDetail/productReviews.module.scss'
import Link from 'next/link'
import GoogleReviewIcon from '@/svgs/googleReviewIcon.svg'
import GoogleLogo from '@/svgs/google.svg'
import { Rate, Spin, Empty } from 'antd'
import productApi from '@/service/modules/productApi'
import { paginationChange } from "@/utils/utils"
import ReviewConfig from "./components/ReviewConfig"
import Chart from "./components/Chart"

interface IProps {
  productID: string,
  hideDetail?: boolean,
  hideTopPage?: boolean,
  changeTabBar?: (tabList: any) => void
  callback?: (data: any) => void
}

export default function GoogleReviews({ productID, hideDetail, hideTopPage = false, changeTabBar, callback }: IProps) {

  const defaultGoogleData = {
    googleReview: [],
    googleReviewCount: 0,
    reviewSummary: [
      {
        count: 0,
        avgScore: 0,
        item: {
          rating1: 0,
          rating2: 0,
          rating3: 0,
          rating4: 0,
          rating5: 0
        }
      }
    ]
  }
  const defaultPages = 1
  const defaultPageSize = 3
  const defalueSort = ""

  const [googleData, setGoogleData]: any = useState(defaultGoogleData)
  const [reviewSummary, setReviewSummary] = useState({ count: 0, item: {}, avgScore: 0 })
  const [sort, setSort] = useState(defalueSort)
  const [pages, setPages] = useState(defaultPages)
  const [pageSize, setPageSize] = useState(defaultPageSize)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    getReviews()
  }, [pages, pageSize, sort])

  const getReviews = async () => {
    setLoading(true)
    const range = paginationChange(pages, pageSize)
    try {
      let res = await productApi.getGoogleReviews({
        productID: productID,
        sort: sort,
        start: range.start,
        rows: range.end
      })
      setLoading(false)
      if (res.data) {
        let newData = res.data
        const { reviewSummary } = res.data

        const tabList = [
          { id: 1, name: 'Customer Reviews' },
          { id: 2, reactNode: <div className={styles['custom-box']}><GoogleReviewIcon style={{ width: '24px', height: "24px", verticalAlign: 'bottom' }} />  {reviewSummary.avgScore} stars with {reviewSummary.count}+ reviews</div> }
        ]
        callback && callback(newData)
        changeTabBar && changeTabBar(tabList)
        if (reviewSummary) {
          setReviewSummary(reviewSummary)
        }
        setGoogleData(newData)
      }
    } catch (error: any) {
      setLoading(false)
      console.error(error)
      callback && callback(null)
    }
  }
  const onpageChange = (page: number, pageSize: number) => {
    setPages(page)
    setPageSize(pageSize)
  }

  const sortChange = (evnet: any) => {
    setSort(evnet)
  }

  return (
    <Spin spinning={loading}>
      {
        !hideDetail
        &&
        <div className={styles['info-box']}>
          <div className={`${styles['left']} ${styles['google']}`}>
            <div className={styles['title']}>
              <GoogleReviewIcon></GoogleReviewIcon>
              <h3>Crazysales Review From Google</h3>
            </div>
            <div className={styles['rate']}>
              <span className={styles['score']}>{reviewSummary.avgScore}</span>
              <Rate count={5} value={reviewSummary.avgScore} style={{ fontSize: '24px' }} allowHalf={true} disabled />
            </div>
            <p className={styles['total']}>{reviewSummary.count} Reviews in total</p>
            <Link href={`/review`} legacyBehavior >
              <a className={styles['see-review']}>See All Google Reviews</a>
            </Link>
            <p className={styles['desc']}>Based on customer reviews and data from Google and/or its partners.</p>
          </div>

          <div className={styles['right']}>
            <div className={styles['title']}>What people are saying</div>
            <Chart reviewSummary={reviewSummary.item} reviewCount={reviewSummary.count} />
          </div>
        </div>
      }

      <div className={`${styles['list-box']} ${styles['google']}`}>
        {
          !hideTopPage
          &&
          <ReviewConfig sort={sort} pages={pages} pageSize={pageSize} total={googleData.googleReviewCount} onpageChange={onpageChange} sortChange={sortChange} productID={productID} activeTab={1} />
        }
        <div className={styles['review-list']}>
          {
            googleData.googleReview.length > 0
              ?
              googleData.googleReview.map((item: any, index: number) => (
                <div className={styles['list-item']} key={index}>
                  <div className={styles['head']}>
                    <div className={styles['left']}>
                      <span className={styles['username']}>{item.name}</span>
                      <Rate count={5} value={item.star} style={{ fontSize: '14px' }} allowHalf={true} disabled />
                    </div>
                  </div>
                  <div className={styles['time']}>{item.createTime}</div>
                  <div className={styles['content']}>
                    <p>{item.review}</p>
                    <div className={styles['google-img']}><GoogleLogo /></div>
                  </div>
                </div>
              ))
              :
              <Empty description="* Get double crazypoints if your review is one of the first three approved!" />
          }
        </div>
        {
          reviewSummary.count > 3
          &&
          <ReviewConfig sort={sort} pages={pages} pageSize={pageSize} total={googleData.googleReviewCount} onpageChange={onpageChange} sortChange={sortChange} productID={productID} activeTab={1} />
        }
      </div>
    </Spin>
  )
}